import { usePost } from '../../../../sharedModules/hooks/useQuery';

const RENDER_BODY_URL = '/collections/statement_scheduled_emails/render_body';

interface RenderBodyParams {
  location: string;
  bill_code: string;
  template_body: string;
}

export interface RenderBodyResponse {
  rendered_body: string;
  warning?: 'invoice_table_not_matched';
}

export function useRenderStatementEmailBody() {
  const mutation = usePost<RenderBodyResponse>();
  const renderEmailBody = (params: RenderBodyParams) => mutation.mutateAsync({ url: RENDER_BODY_URL, data: params });
  return { renderEmailBody, isLoading: mutation.isPending, isError: mutation.isError };
}
